module.exports = __webpack_public_path__ + "media/9-jiu.5356fe87.mp3";